import { Container } from "./styles";
import facepalm from "../../../assets/facepalm.svg";
import thumbsup from "../../../assets/thumbsup.svg";
import { buildWidgetAssetUrl } from "../../../widgetAssetUrl";

export function WidgetError() {
  return (
    <Container>
      <div>
        <p>Oops! This wasn't supposed to happen...</p>
        <img alt="Facepalm" src={buildWidgetAssetUrl(facepalm)} />
      </div>
      <div>
        <p>...please refresh the page and try again</p>
        <img alt="Facepalm" src={buildWidgetAssetUrl(thumbsup)} />
      </div>
    </Container>
  );
}
